// extracted by mini-css-extract-plugin
export default {"shimmer":"Shimmer_shimmer__TZT9e","shimmerSweep":"Shimmer_shimmerSweep__S3xPU","circle":"Shimmer_circle__bHr4U"};